import { render, staticRenderFns } from "./yaopin.vue?vue&type=template&id=61454a58&scoped=true&"
import script from "./yaopin.vue?vue&type=script&lang=js&"
export * from "./yaopin.vue?vue&type=script&lang=js&"
import style0 from "./yaopin.vue?vue&type=style&index=0&id=61454a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61454a58",
  null
  
)

export default component.exports